<ul class="list-group">
  <a *ngFor="let lesson of lessons; let i = index"
     [ngClass]="(i+1)==index ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'"
     [routerLink]="['../', i+1]"
  >
    {{ lesson.title }}
  </a>
</ul>
